module.exports = __webpack_public_path__ + "img/w3_maximize_white.f9049f0a.png";